// styles
import "./styles.scss";

// import ellipse1 from "../../assets/images/ellipse-1.svg";
// import ellipse2 from "../../assets/images/ellipse-2.svg";
// import ellipse3 from "../../assets/images/ellipse-3.svg";
import heroImg from "../../assets/images/hero-img.png";
import PrimaryButton from "../primaryButton";
import scrollTo from "../../utils/scrollTo";

function HeroSec({ label, heading, description }) {
  return (
    <>
      <div className="hero-sec-container" id="aboutus">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-6 column">
              <div className="image-box text-right">
                {/* <img className="ellipse right absolute" src={ellipse3} alt="ellipse" /> */}
                <img className="image" src={heroImg} alt="hero img" />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6 column">
              <div className="content-box relative">
                {/* <img className="ellipse top absolute" src={ellipse2} alt="ellipse" /> */}
                <div className="label-text text-black opacity--0.7">
                  {label}
                </div>
                <h1 className="heading text-black">{heading}</h1>
                <div className="description text-black">{description}</div>
                {/* <img className="ellipse left absolute" src={ellipse1} alt="ellipse" /> */}
                <div className="get-in-touch-btn-box">
                  <PrimaryButton
                    className="get-in-touch-btn"
                    onClick={() => {
                      scrollTo("nameFieldQueryForm");
                    }}
                    buttonName="Get In Touch"
                    type="submit"
                    // disabled={loader}
                    // loader={loader}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="get-in-touch-btn-bottom-box">
          <PrimaryButton
            className="get-in-touch-btn"
            onClick={() => {
              scrollTo("nameFieldQueryForm");
            }}
            buttonName="Get In Touch"
            type="submit"
            // disabled={loader}
            // loader={loader}
          />
        </div>
      </div>
    </>
  );
}
export default HeroSec;
